import React from 'react';
import './Tooltip.css'
import TooltipItem from "./TooltipItem";

class Tooltip extends React.Component {

    render () {
        let opacity = 0;
        let left = "";
        let right = "";
        let top = 0;
        let rotulo = "";
        //let zIndex = 0;
        if (this.props.estilo) {
            opacity = this.props.estilo.opacity;
            left = this.props.estilo.left;
            right = this.props.estilo.right;
            top = this.props.estilo.top;
            rotulo = this.props.periodo.rotulo;
            //zIndex = this.props.estilo.zIndex;
        }

        return (
            <div id="chartjs-tooltip" className="center"
                 style={{
                     transition: "opacity: 1s, top: .1s",
                     position: "absolute",
                     fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
                     fontSize: 12,
                     fontStyle: "normal",
                     backgroundColor: "rgb(255, 255, 255)",
                     //zIndex: zIndex,
                     opacity: opacity,
                     left: left,
                     top: top,
                     right: right,
                     minWidth: "160px",
                     maxWidth: "300px"
                 }}>
                <div className="tooltip-custom">
                    <ul className="list-group">
                        <li className="list-group-item tooltip-header">
                            <div className="row">
                                <div className="col-12 tooltip-header">
                                    <strong> {rotulo} </strong><br/>
                                </div>
                            </div>
                        </li>
                        {this.props.itens.map(politico => {
                            return <TooltipItem periodo={this.props.periodo}
                                                politico={politico}
                                                cidade={this.props.cidade}/>
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/scenes/Home/components/GraficoSentimento/Tooltip.js